import { dec, type Decimal } from '../core/decimal.ts';
import type { TaxAdvantagedAccount } from '../types/domain.ts';

/** TaxAdvantagedAccount.defaultTaxRelief (percent). */
export function defaultTaxRelief(account: TaxAdvantagedAccount): Decimal {
  switch (account) {
    case 'sipp':
    case 'workplace_pension':
      return dec(20);
    case '401k_traditional':
    case 'ira_traditional':
    case 'hsa':
      return dec(22);
    default:
      return dec(0);
  }
}
